var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('footer',[_c('small',[_vm._v("© 2020 Solis Engineering")]),_c('small',[_vm._v(" - client version: "+_vm._s(_vm.version)+" ")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }